import { useAuth } from "@/context/AuthContext";
import { AppShell } from "@/components/layout/AppShell";
import { CrudPanel } from "@/components/library/CrudPanel";

export default function SettingsMaterials() {
  const { user } = useAuth() as any;
  const admin = user?.role === "admin";
  return (
    <AppShell title="Settings · Materials">
      <p className="mb-4 text-sm text-gray-500">These items appear in the “Add material…” drop-down on every work order, where crews record quantities Anticipated, Supplied, Used and Returned. Turn on “Needs description” to add a text box (e.g. colour or length) next to the item.</p>
      <CrudPanel path="materials" title="Materials catalogue" testid="materials" canEdit={admin} cloneable emptyText="Add the parts and consumables your crews use."
        fields={[
          { key: "name", label: "Item name" },
          { key: "unit", label: "Unit", type: "select", options: [{ value: "ea", label: "each" }, { value: "ft", label: "feet" }, { value: "box", label: "box" }, { value: "roll", label: "roll" }] },
          { key: "has_note", label: "Needs description box", type: "checkbox" },
          { key: "note_label", label: "Description label (e.g. Colour, Length)" },
          { key: "sort_order", label: "Order", type: "number" },
        ]} />
    </AppShell>
  );
}
